<script setup lang="ts">
import { ref } from 'vue'
import { NXGDSButton, NXGDSButtonVariants } from '@nsftx/seven-nxg-design-system'
import type { LatestBetslipAction } from '@/composables/useLatestBetslipActions/useLatestBetslipActions'

interface LatestBetslipsActionsProps {
  actions: LatestBetslipAction[]
}

interface LatestBetslipsActionsEmits {
  'click:action': []
}

const { actions } = defineProps<LatestBetslipsActionsProps>()
const emit = defineEmits<LatestBetslipsActionsEmits>()

const loadingActionId = ref<string | null>(null)

const handleActionClick = async (action: LatestBetslipAction) => {
  loadingActionId.value = action.id

  try {
    await action.onClick()
    emit('click:action')
  } finally {
    loadingActionId.value = null
  }
}
</script>

<template>
  <div class="ss-latest-betslips-actions ss-d-flex-column">
    <NXGDSButton
      v-for="action in actions"
      :key="action.id"
      :variant="NXGDSButtonVariants.secondary"
      width="100%"
      :prepend-icon="action.icon"
      @click="() => handleActionClick(action)"
      :loading="loadingActionId === action.id"
    >
      {{ action.name }}
    </NXGDSButton>
  </div>
</template>

<style scoped lang="scss">
.ss-latest-betslips-actions {
  max-width: 170px;
  width: 100%;
  gap: 5px;
  padding: var(--nxgds-alias-spacing-xs);
  background-color: var(--nxgds-mapped-color-surface-component-card-default);
  border-radius: var(--nxgds-alias-radius-corner-theme);
  box-shadow: 0 8px 1rem 0 rgba(26, 28, 29, 0.75);
}
</style>
